import { Component, OnInit } from '@angular/core';
import { TodoServiceService } from '../todo-service.service';
import { IToDo } from '../todo';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
//import { Kasse } from '../kasse';
@Component({
  selector: 'app-app-todo',
  templateUrl: './app-todo.component.html',
  styleUrls: ['./app-todo.component.scss']
})
export class AppTodoComponent implements OnInit {
  public myPassword="";//: FormGroup;

  newInput: IToDo;


  hidecode = false;
  hide = true;
  title ="ToDo";

  ToDoP: IToDo[];
  dataSource: MatTableDataSource<IToDo>;
  selection = new SelectionModel<IToDo>(true, []);
  name?: string;
  date?: string;
  state?: number;
  finishdate?: string;
  note?: string;
  displayedColumns: string[] = ["name", "date", "state", "finishdate", "note"];
  constructor(private ITodo: TodoServiceService) { }

  ngOnInit(): void {

    this.getTodo();
  }
  getTodo():void
  {

    
    let init: number;
    init=0;

    this.ITodo.getToDo()
    .subscribe((data)=> {this.ToDoP=data; console.log(this.ToDoP); 
 

  

  
  

      })



  }

  onPasswordInput() {

    if (this.myPassword=="tschockl")
    {
      this.hidecode = true;
    }
    else
    {
      this.hidecode=false;
    }


  }

  getStateColor(state){
    switch (state) {
      case '0':
        return 'red'
      case '1':
        return 'green';
      case '2':
        return 'blue';
    }
}
}
